module.exports = __webpack_public_path__ + "img/s3CardIcon4.57057023.png";